import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c6cd5ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tilte" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "订单号", -1))

import { useRouter } from 'vue-router'
import { getThousandMoney } from '@/utils/index'
import { XssCommonPageListQuery } from '@/types/public'
import { List, PullRefresh, Button, Dialog } from 'vant'
import { CacheSelectServiceChargeOrderInfoKey } from '@/config/insurance'
import { ServiceChargeListDataItem, ServiceChargeListDataItemType } from '@/types/insurance'
import useCommonList, { PageParams, PageListResut } from '@/compositions/useCommonList'
import AppHeader from '@/components/Header.vue'
import BaseInfoList from '../components/base-info-list.vue'
import InvoiceApplyCheck from '@/components/invoice/invoice-apply-check.vue'
import { getTechnicalSupportInvoiceList } from '@/apis/malfunction-repair'
import type {TechnicalSupportInvoiceListItem,TechnicalSupportInvoiceListItemType} from '@/types/malfunction-repair'



export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const $router = useRouter()

async function queryList(
  params: PageParams & XssCommonPageListQuery
): Promise<PageListResut<TechnicalSupportInvoiceListItemType>> {
  try {
    const data = await getTechnicalSupportInvoiceList({
      ...params,
    })
    const result = {
      ...data,
      data: data.data.map((item: TechnicalSupportInvoiceListItem) => {
        let orderInfo = [
          {
            label: '订单状态',
            value: item.status_text,
          },
          { label: '订单支付金额', value: `¥ ${getThousandMoney(Number(item.price))}` },
        ]
        if (item.pay_at) {
          orderInfo.push({ label: '订单支付时间', value: item.pay_at })
        }
        return {
          ...item,
          orderInfo,
        }
      }),
    }
    return result
  } catch (error) {
    console.log('error', error)
    return Promise.reject(error)
  }
}
const {
  refreshing,
  loading,
  requestError,
  finished,
  onRefresh,
  dataList,
  queryHandle,
  finishedText,
} = useCommonList<TechnicalSupportInvoiceListItemType, PageParams & XssCommonPageListQuery>(queryList, {})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "付费技术支持订单" }),
    _createVNode(_unref(PullRefresh), {
      modelValue: _unref(refreshing),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : null)),
      onRefresh: _unref(onRefresh),
      class: "list-wrap"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(List), {
          loading: _unref(loading),
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
          error: _unref(requestError),
          "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
          finished: _unref(finished),
          offset: 200,
          "finished-text": _unref(finishedText),
          "error-text": "加载失败",
          onLoad: _unref(queryHandle),
          class: "list-container"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.serial_number,
                class: "van-hairline--surround list-item"
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _createElementVNode("div", null, _toDisplayString(item.service_no), 1)
                ]),
                _createVNode(BaseInfoList, {
                  list: item.orderInfo,
                  listItemJustifyContent: "space-between",
                  listItemMt: 8,
                  class: "van-hairline--top"
                }, null, 8, ["list"]),
                (item.invoice?.url)
                  ? (_openBlock(), _createBlock(InvoiceApplyCheck, {
                      key: 0,
                      url: item.invoice?.url,
                      time: item.invoice?.created_at,
                      orderNo: item.service_no
                    }, null, 8, ["url", "time", "orderNo"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "error", "finished", "finished-text", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ], 64))
}
}

})